import { useMemo } from 'react';
import { Stack, Toast } from '@adc/parallax-component-library';
import { styled } from '@tamagui/core';
import {
  createRootRoute,
  Outlet,
  useRouterState,
} from '@tanstack/react-router';

import { Footer } from '~/components/navigation/Footer';
import { Header } from '~/components/navigation/Header';
import { NotFoundRoute } from '~/components/NotFoundRoute';
import { PageContainer } from '~/components/PageContainer';
import { ModalProvider } from '~/features/modals/ModalProvider';

export const Route = createRootRoute({
  component: RootComponent,
  notFoundComponent: NotFoundRoute,
});

const ROUTES_WITH_FOOTER = ['/login'] as const;

const ROOT_STACK_ID = 'root-stack';

const ToastContainer = styled(Stack, {
  position: 'absolute',
  zIndex: 9999,
  width: '100%',
  maxWidth: 343,
  right: 16,
  top: 140 + 16, // 140 from the header + 16 for the spacing,
});

function RootComponent() {
  const route = useRouterState({
    select: (s) => s.location.pathname,
  });

  const specialMargin = useMemo(() => {
    // No horizontal margin for login route
    if (route === '/login') {
      return '$0';
    }

    return undefined;
  }, [route]);

  return (
    <ModalProvider>
      <ToastContainer>
        <Toast testID="toast" />
      </ToastContainer>
      <Header />
      <PageContainer
        id={ROOT_STACK_ID}
        marginHorizontal={specialMargin}
        marginVertical={specialMargin}
      >
        <Outlet />
      </PageContainer>
      {ROUTES_WITH_FOOTER.includes(route) && <Footer />}
    </ModalProvider>
  );
}
